module.exports = __webpack_public_path__ + "img/404.6e0f5e76.png";